export function relationshipIntakePath(pathname, relationshipId, customerName, extraParams = {}) {
  const params = new URLSearchParams();
  const cleanRelationshipId = String(relationshipId || "").trim();
  const cleanCustomerName = String(customerName || "").trim();
  if (cleanRelationshipId) params.set("relationshipId", cleanRelationshipId);
  if (cleanCustomerName) params.set("customerName", cleanCustomerName);
  Object.entries(extraParams || {}).forEach(([key, value]) => {
    const cleanValue = String(value ?? "").trim();
    if (cleanValue) params.set(key, cleanValue);
  });
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}
